<template>
	<div id="postcard" :class="{'postcard--animate': $store.state.form.to.message != ''}">
		<h2>Preview</h2>
		<div class="flex">
			<div class="left">
				<p class="message">
					<span v-if="$store.state.form.to.message">{{$store.state.form.to.message}}</span>
					<span v-else>It was not just the medical care, but also the reassuring words and support that helped me to get better. Thanks Dr Askin and everyone at POW.</span>
				</p>
				<p class="from-to">
					TO: <strong v-if="$store.state.form.to.name">{{$store.state.form.to.name}}</strong><strong v-else>Dr. Askin</strong><br>
					FROM: <strong v-if="$store.state.form.from.name">{{$store.state.form.from.name}}</strong><strong v-else>Elisabeth Walter</strong>
				</p>
			</div>
			<div class="right">
				<img src="@/assets/images/ico-gift-blue.svg" v-if="$store.state.form.gift === null" height="82">
				<div :class="['lottie', `lottie--${gift}`]" ref="lottie"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { gifts } from '@/constants';
import lottie from 'lottie-web';

export default {
	data () {
		return {
			animation: null,
		};
	},
	computed: {
		gift () {
			let gift = '';
			for (const key in gifts) {
				if (gifts[key] === this.$store.state.form.gift) {
					return gift;
				}
				gift = gifts[key];
			}
			return '';
		},
	},
	watch: {
		gift (newVal) {
			this.reloadAnimation();
		},
	},
	methods: {
		reloadAnimation () {
			if (this.animation !== null) {
				this.animation.destroy();
			}

			this.animation = lottie.loadAnimation({
				container: this.$refs.lottie,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				animationData: require(`@/assets/json/${this.gift}.json`),
			});
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../../assets/less/default.less';

	#postcard { position: relative; z-index: 10; min-width: 317px; min-height: 224px; border: 2px solid @blue; box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.2);
		background-color: #fff;
		background-image: url(../../assets/images/logo.svg), url(../../assets/images/logo.svg);
		background-position: left -120% bottom -105px, 250% -30%;
		background-repeat: no-repeat;
		background-size: 70%, 70%;
		&:before { opacity: 0; transition: opacity 0.6s ease; .pseudo(); .top-left(-40px, -40px); .size(70px, 51px); .bg('../../assets/images/ico-lines-big_animated.svg', 0 0 / contain); }
		&.postcard--animate:before { opacity: 1; }
	}
	h2 { margin: 1rem 0 0.2rem 0; color: @grey; font-size: 14/16rem; text-transform: uppercase; }
	strong { color: @blue; font-family: 'futura-pt-bold', sans-serif; font-weight: 700; }

	.flex { display: flex; margin-bottom: 30px; }
	.left { width: 60%; padding: 0 24px 0 24px; border-right: 2px dotted @grey; text-align: left; line-height: 1.3; font-size: 14/16rem;
		p.message { position: relative; height: 120px; max-height: 120px;
			span { display: block; .size(100%); overflow: hidden; }
			&:before { .top-left(-2rem,0); content: '“'; font-size: 2rem; }
			&:after { .bottom-right(0,-1ex); content: '“'; font-size: 2rem; }
		}
	}
	.right { display: flex; justify-content: center; align-items: flex-end; width: 40%; background: transparent url(../../assets/images/ico-stamp.svg) 50% 0 no-repeat; background-size: 76px;
		img { width: 58px; margin-bottom: .5rem; }
		.lottie { width: 100%;
			&:empty { display: none; }
			&--envelope { transform: translate(-5%, 30%); }
			&--giftbox { transform: translate(0, 15%); }
			&--chocolate { transform: translate(0, 15%); }
			&--flowers { transform: translate(0, 15%); }
			&--bear { transform: translate(0, 15%); }
		}
	}

	@media @mobile {
		#postcard:before { display: none; }
	}

</style>



// WEBPACK FOOTER //
// src/components/TheForm/TheFormPostcard.vue